import React, { CSSProperties } from "react";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { CheckboxUnchecked, CheckboxChecked } from "components/Icons";
import { useController } from "react-hook-form";

import { useSmartFormContext } from "components/SmartForm";

import { SxProps, Theme } from "@mui/material";
import * as S from "./styles";

export type SmartFormSingleCheckboxT = {
  name: string;
  checkboxLabel: string | JSX.Element;
  label?: string;
  helperText?: string | undefined;
  error?: boolean;
  disabled?: boolean;
  labelStyle?: CSSProperties;
  checkboxLabelSx?: SxProps<Theme>;
} & CheckboxProps;

const SmartFormSingleCheckbox = ({
  name,
  checkboxLabel,
  label,
  helperText,
  error,
  disabled = false,
  labelStyle = {},
  checkboxLabelSx = {},
  ...rest
}: SmartFormSingleCheckboxT) => {
  const { controllerProps } = useSmartFormContext();
  const { field } = useController({ ...controllerProps, name });

  return (
    <>
      <S.LabelGroupWrapper>
        <S.StyledFormLabel style={labelStyle}>{label}</S.StyledFormLabel>
      </S.LabelGroupWrapper>
      <S.CheckboxWrapper
        checked={field.value}
        disabled={disabled}
        {...field}
        control={
          <Checkbox
            size="small"
            icon={<CheckboxUnchecked />}
            checkedIcon={
              <CheckboxChecked
                {...(disabled
                  ? {
                      fill: "rgba(153, 194, 252, 1)",
                    }
                  : {})}
              />
            }
            {...rest}
          />
        }
        label={
          <S.CheckboxLabel component="span" sx={checkboxLabelSx}>
            {checkboxLabel}
          </S.CheckboxLabel>
        }
        labelPlacement="end"
      />
      <S.StyledHelperText error={error}>{helperText}</S.StyledHelperText>
    </>
  );
};

export default SmartFormSingleCheckbox;
